import { Component, EventEmitter, OnInit } from '@angular/core';
import { SessionStorageService } from '@app/core/local-storage/local-storage.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ActionAuthLoginSuccess } from '../../auth.reducer';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from '../../authentication.service';
import { IPackData } from '@app/certificates/packs/packs';


@Component({
  selector: 'business-login',
  templateUrl: './business-login.component.html',
  styleUrls: ['./business-login.component.scss']
})
export class BusinessLoginComponent implements OnInit {

  accountSelected: EventEmitter<any> = new EventEmitter<any>();
  accounts = [];
  selected;
  businessAccountId;
  packData: IPackData;
  constructor(private translate: TranslateService,
    private store: Store<any>,
    private sessionStorageService: SessionStorageService,
    private router: Router,
    private dialog: MatDialog,
    private auth: AuthenticationService,
  ) { }

  ngOnInit() {
    this.dialog.closeAll();
    this.accounts = this.sessionStorageService.getItem("accounts");
    // this.auth.packs$.subscribe(packs => {
    //   this.packData = {
    //     ...this.packData,
    //     items: packs
    //   };
    // });
    this.getCurrentLoggedInAccount();
  }

  getName(a) {
    return this.translate.currentLang === 'bg' ? a.nameBg : a.nameEn;
  }

  getCurrentLoggedInAccount() {
    this.businessAccountId = this.sessionStorageService.getItem("businessAccountId");
    if (this.businessAccountId) {
      if (this.businessAccountId == 'personal') {
        this.selected = 'personal';
      } else {
        const company = this.accounts.find(item => item.cmrId === this.businessAccountId);
        this.selected = company.cmrId;
      }
    } else {
      this.selected = 'personal';
    }
  }

  continueLogin() {
    this.sessionStorageService.businessAccountId.next(this.selected);
    this.sessionStorageService.setItem("businessAccountId", this.selected);
    if (this.selected == 'personal') {
      this.router.navigateByUrl('/manage/signing');
      this.store.dispatch(new ActionAuthLoginSuccess({ auth: this.sessionStorageService.getItem('loginEventData') }));
    } else {
      this.store.dispatch(new ActionAuthLoginSuccess({ auth: this.sessionStorageService.getItem('loginEventData') }));
      this.auth.loginOnlyQESShowProfile(false);
      this.router.navigateByUrl('/business/signing');
    }
  }
}
